// Files (screenshots, images) in a paste, the same on every system.
//
// A screenshot copied to the clipboard (macOS Cmd+Ctrl+Shift+4, Windows Win+Shift+S) reaches a
// page as one image/png file: types ["Files"]. A file copied in the Finder or Explorer comes as
// its name in text/plain plus the file: types ["text/plain", "Files"] (Chromium
// ui/base/clipboard/clipboard_mac.mm, blink data_object.cc). Editors that take text/plain first
// (BlockNote's paste order) paste the file's NAME instead of the image. Rich text from Word or a
// web page may carry a picture of itself too, but always with text/html: that stays text.

/** The files in a clipboard event (items first: some browsers fill only one of the two). */
export function clipboardFiles(event) {
  const data = event?.clipboardData;
  if (!data) return [];
  const fromItems = [...(data.items || [])].filter((i) => i.kind === 'file').map((i) => i.getAsFile()).filter(Boolean);
  return fromItems.length ? fromItems : [...(data.files || [])];
}

/** Whether this paste is files (a screenshot, a copied file) rather than text that brings a picture. */
export function isFilePaste(event) {
  const data = event?.clipboardData;
  const files = clipboardFiles(event);
  if (!data || !files.length) return false;
  const types = [...(data.types || [])];
  if (types.includes('text/html')) return false;
  const text = (data.getData('text/plain') || '').trim();
  if (!text) return true;
  // The Finder / Explorer: the text is the copied files' names (or their paths).
  const names = files.map((f) => f.name);
  return text.split(/\r?\n/).every((line) => names.some((n) => line.trim().endsWith(n)));
}
